import React, { useState } from 'react';
import '../styles/Support.css';
import { FaQuestionCircle, FaEnvelope, FaPaperPlane, FaChevronDown, FaChevronUp } from 'react-icons/fa';

const Support = () => {
    const [activeIndex, setActiveIndex] = useState(null);
    const [formData, setFormData] = useState({ subject: '', message: '' });

    const faqs = [
        {
            question: "كيف يمكنني إنشاء دورة جديدة؟",
            answer: "يمكنك إنشاء دورة جديدة بالذهاب إلى صفحة 'الدورات' والضغط على زر 'إضافة دورة جديدة'. ستحتاج لإدخال اسم الدورة ووصفها."
        },
        {
            question: "كيف أضيف طلاباً إلى الدورة؟",
            answer: "بعد إنشاء الدورة، سيتم توليد 'كود دخول' خاص بها. شارك هذا الكود مع طلابك ليتمكنوا من الانضمام للدورة من خلال حساباتهم."
        },
        {
            question: "هل يمكنني تعديل الامتحان بعد نشره؟",
            answer: "نعم، يمكنك الذهاب إلى صفحة الامتحانات والضغط على زر 'تعديل' بجانب الامتحان المراد تغييره. يمكنك تعديل التفاصيل وإضافة أو حذف الأسئلة."
        },
        {
            question: "كيف أرفع محاضرة فيديو؟",
            answer: "اذهب إلى صفحة 'رفع محاضرة'، اختر الدورة، ثم قم برفع ملف الفيديو (MP4) أو ملف PDF. يمكنك أيضاً إضافة وصف ومحتوى نصي للمحاضرة."
        }
    ];

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const handleContactSubmit = (e) => {
        e.preventDefault();
        alert("✅ تم إرسال رسالتك بنجاح! سيقوم فريق الدعم بالرد عليك قريباً.");
        setFormData({ subject: '', message: '' });
    };

    return (
        <div className="support-container fade-in">
            <div className="support-header">
                <h1><FaQuestionCircle /> مركز المساعدة والدعم</h1>
                <p>نحن هنا لمساعدتك في إدارة العملية التعليمية بسهولة</p>
            </div>

            <div className="support-content">
                {/* FAQ Section */}
                <div className="faq-section">
                    <h2>الأسئلة الشائعة</h2>
                    <div className="accordion">
                        {faqs.map((faq, index) => (
                            <div key={index} className={`accordion-item ${activeIndex === index ? 'active' : ''}`}>
                                <button className="accordion-header" onClick={() => toggleAccordion(index)}>
                                    <span>{faq.question}</span>
                                    {activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                                </button>
                                <div className="accordion-body">
                                    <p>{faq.answer}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Contact Form Section */}
                <div className="contact-section">
                    <h2><FaEnvelope /> تواصل مع الدعم الفني</h2>
                    <form onSubmit={handleContactSubmit} className="contact-form">
                        <div className="form-group">
                            <label>الموضوع</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="مثال: مشكلة في تسجيل الدخول"
                                value={formData.subject}
                                onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label>الرسالة</label>
                            <textarea
                                className="form-control"
                                rows="5"
                                placeholder="اشرح مشكلتك بالتفصيل..."
                                value={formData.message}
                                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                                required
                            ></textarea>
                        </div>
                        <button type="submit" className="btn-primary btn-block">
                            <FaPaperPlane /> إرسال الرسالة
                        </button>
                    </form>

                    <div className="direct-contact">
                        <p>أو راسلنا مباشرة عبر البريد الإلكتروني:</p>
                        <a href="mailto:info@daress.app" className="email-link">info@daress.app</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Support;
